const constantValues = {
  PGNEET_PROD_URL: "https://pgneet.info/pgneet/user/api",
  // PGNEET_PROD_URL: "http://localhost:5000/pgneet/user/api"
};
export default constantValues;
